// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/map.white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/list.white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/map.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/list.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/filter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/route.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/route.white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/detail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/heart_fav_solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/hamburger.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/cart.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/sort_asc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/sort_desc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/sorting_alt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/grid_view_large_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/grid_view_large_solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/grid_view_small_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/grid_view_small_solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/telegram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/social_facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/social_odnoklassniki.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/social_vkontakte.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/social_instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/social_youtube.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/arrow_right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/whatsapp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/phone_incoming.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/chat_double.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/mail_envelope.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/empty.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.icon:before {
    display: inline-block;
    height: 24px;
    width: 24px;
    background-size: cover;
}
.icon_small:before {
    display: inline-block;
    height: 1.2em;
    width: 1.2em;
    background-size: cover;
}

.icon > span {
    display: inline-block;
    padding-left: 10px;
}

.icon-map-white:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.icon-list-white:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.icon-map:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.icon-list:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.icon-filter:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.icon-route:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.icon-route-white:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.icon-detail:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.icon-user:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.icon-fav:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.icon-hamburger:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.icon-cart:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.icon-asc:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.icon-desc:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.icon-sort:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.icon-grid-3:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.icon-grid-3.active:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.icon-grid-4:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.icon-grid-4.active:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.icon-search:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.icon-minus:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.icon-plus:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.icon-telegram:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.icon-facebook:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.icon-odnoklassniki:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.icon-vkontakte:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.icon-instagram:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.icon-youtube:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.icon-arrow-right:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.icon-whatsapp:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.icon-phone-incoming:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.icon-chat:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.icon-envelop:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.icon-phone:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.icon-check:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.icon-empty:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/icons.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gDAAkC;AACtC;AACA;IACI,gDAAmC;AACvC;AACA;IACI,gDAA4B;AAChC;AACA;IACI,gDAA6B;AACjC;AACA;IACI,gDAA+B;AACnC;AACA;IACI,gDAA8B;AAClC;AACA;IACI,gDAAoC;AACxC;AACA;IACI,gDAA+B;AACnC;AACA;IACI,gDAA6B;AACjC;AACA;IACI,gDAAwC;AAC5C;AACA;IACI,iDAAkC;AACtC;AACA;IACI,iDAA6B;AACjC;AACA;IACI,iDAAiC;AACrC;AACA;IACI,iDAAkC;AACtC;AACA;IACI,iDAAoC;AACxC;AACA;IACI,iDAAgD;AACpD;AACA;IACI,iDAA8C;AAClD;AACA;IACI,iDAAgD;AACpD;AACA;IACI,iDAA8C;AAClD;AACA;IACI,iDAA+B;AACnC;AACA;IACI,iDAA8B;AAClC;AACA;IACI,iDAA6B;AACjC;AACA;IACI,iDAAiC;AACrC;AACA;IACI,iDAAwC;AAC5C;AACA;IACI,iDAA6C;AACjD;AACA;IACI,iDAAyC;AAC7C;AACA;IACI,iDAAyC;AAC7C;AACA;IACI,iDAAuC;AAC3C;AACA;IACI,iDAAoC;AACxC;AACA;IACI,iDAAiC;AACrC;AACA;IACI,iDAAuC;AAC3C;AACA;IACI,iDAAoC;AACxC;AACA;IACI,iDAAsC;AAC1C;AACA;IACI,iDAA8B;AAClC;AACA;IACI,iDAA8B;AAClC;AACA;IACI,iDAA8B;AAClC","sourcesContent":[".icon {\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.icon:before {\n    display: inline-block;\n    height: 24px;\n    width: 24px;\n    background-size: cover;\n}\n.icon_small:before {\n    display: inline-block;\n    height: 1.2em;\n    width: 1.2em;\n    background-size: cover;\n}\n\n.icon > span {\n    display: inline-block;\n    padding-left: 10px;\n}\n\n.icon-map-white:before {\n    content: url(../img/map.white.svg);\n}\n.icon-list-white:before {\n    content: url(../img/list.white.svg);\n}\n.icon-map:before {\n    content: url(../img/map.svg);\n}\n.icon-list:before {\n    content: url(../img/list.svg);\n}\n.icon-filter:before {\n    content: url(../img/filter.svg);\n}\n.icon-route:before {\n    content: url(../img/route.svg);\n}\n.icon-route-white:before {\n    content: url(../img/route.white.svg);\n}\n.icon-detail:before {\n    content: url(../img/detail.svg);\n}\n.icon-user:before {\n    content: url(../img/user.svg);\n}\n.icon-fav:before {\n    content: url(../img/heart_fav_solid.svg);\n}\n.icon-hamburger:before {\n    content: url(../img/hamburger.svg);\n}\n.icon-cart:before {\n    content: url(../img/cart.svg);\n}\n.icon-asc:before {\n    content: url(../img/sort_asc.svg);\n}\n.icon-desc:before {\n    content: url(../img/sort_desc.svg);\n}\n.icon-sort:before {\n    content: url(../img/sorting_alt.svg);\n}\n.icon-grid-3:before {\n    content: url(../img/grid_view_large_outline.svg);\n}\n.icon-grid-3.active:before {\n    content: url(../img/grid_view_large_solid.svg);\n}\n.icon-grid-4:before {\n    content: url(../img/grid_view_small_outline.svg);\n}\n.icon-grid-4.active:before {\n    content: url(../img/grid_view_small_solid.svg);\n}\n.icon-search:before {\n    content: url(../img/search.svg);\n}\n.icon-minus:before {\n    content: url(../img/minus.svg);\n}\n.icon-plus:before {\n    content: url(../img/plus.svg);\n}\n.icon-telegram:before {\n    content: url(../img/telegram.svg);\n}\n.icon-facebook:before {\n    content: url(../img/social_facebook.svg);\n}\n.icon-odnoklassniki:before {\n    content: url(../img/social_odnoklassniki.svg);\n}\n.icon-vkontakte:before {\n    content: url(../img/social_vkontakte.svg);\n}\n.icon-instagram:before {\n    content: url(../img/social_instagram.svg);\n}\n.icon-youtube:before {\n    content: url(../img/social_youtube.svg);\n}\n.icon-arrow-right:before {\n    content: url(../img/arrow_right.svg);\n}\n.icon-whatsapp:before {\n    content: url(../img/whatsapp.svg);\n}\n.icon-phone-incoming:before {\n    content: url(../img/phone_incoming.svg);\n}\n.icon-chat:before {\n    content: url(../img/chat_double.svg);\n}\n.icon-envelop:before {\n    content: url(../img/mail_envelope.svg);\n}\n.icon-phone:before {\n    content: url(../img/phone.svg);\n}\n.icon-check:before {\n    content: url(../img/check.svg);\n}\n.icon-empty:before {\n    content: url(../img/empty.svg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
